/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _class2, _descriptor2, _descriptor3, _descriptor4, _ConstantMonitoringEditionComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import CompoundSurveyFrequency from "compound-survey/models/compound-survey-frequency";
import ForcBaseComponent from "core/components/forc/abstract/base-component";
import ConfigurationVitalSignModel from "core/models/configuration-vital-sign";
import Patient from "core/models/patient";
import VitalSignItem from "core/models/vital-sign/vital-sign-item";
import ConfigurationService, { Configuration } from "core/services/configuration";
import { Changeset } from "ember-changeset";
import { BufferedChangeset } from "ember-changeset/types";
import IntlService from "ember-intl/services/intl";
let ConstantMonitoringModelView = (_class = class ConstantMonitoringModelView {
  constructor(store, patient, configurationVitalSign, surveyFrequencies) {
    _initializerDefineProperty(this, "isCustomDirty", _descriptor, this);
    this.store = store;
    this.patient = patient;
    this.configurationVitalSign = configurationVitalSign;
    this.surveyFrequencies = surveyFrequencies;
  }
  async save() {
    // Create a new CompoundSurveyFrequenciesChangedJe that contains only enabled frequencies
    const freqChangedJeReq = this.store.createRecord("compound-survey-frequencies-changed-journal-event", {
      patient: this.patient,
      occurredAt: new Date(),
      source: "wise",
      enabledSurveyFrequencies: this.surveyFrequencies.filter(f => f.enabled)
    }).save();
    await Promise.all([this.configurationVitalSign.save(), freqChangedJeReq]);
  }
  get filteredVitalSigns() {
    const followUpReasonIdsToFilter = ["digest-rch", "digest-crohn"];
    if (followUpReasonIdsToFilter.includes(this.patient.followUpReasonId)) {
      if (this.patient.followUpReasonId === "digest-rch") {
        return this.configurationVitalSign.vitalSigns.filter(v => v.id !== "crohn-survey");
      }
      if (this.patient.followUpReasonId === "digest-crohn") {
        return this.configurationVitalSign.vitalSigns.filter(v => v.id !== "rch-survey");
      }
    }
    return this.configurationVitalSign.vitalSigns;
  }
  get constants() {
    return [...this.filteredVitalSigns, ...this.surveyFrequencies];
  }
  get enabledConstants() {
    return this.constants.filter(c => c.enabled);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isCustomDirty", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
let ConstantMonitoringEditionComponent = (_class2 = (_ConstantMonitoringEditionComponent = class ConstantMonitoringEditionComponent extends ForcBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "configuration", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "store", _descriptor4, this);
    _defineProperty(this, "labelFromConstant", constant => {
      if (constant instanceof VitalSignItem) {
        return this.getVitalSignLabel(constant);
      } else if (constant instanceof CompoundSurveyFrequency) {
        return this.getCompoundSurveyLabel(constant);
      }
      return "";
    });
  }
  get changeset() {
    if (this._changeset) return this._changeset;
    const configuration = this.configuration.configurationForPatient(Configuration.VitalSign, this.patient);
    const compoundSurveyFrequencies = this.patient.surveyFrequencies;
    this._changeset = Changeset(new ConstantMonitoringModelView(this.store, this.patient, configuration, compoundSurveyFrequencies));
    return this._changeset;
  }
  get shouldShowFrequency() {
    return this.patient.tlsAgreed && this.changeset.enabledConstants.some(constant => Boolean(constant.frequency));
  }
  get shouldShowForgetting() {
    return this.patient.tlsAgreed && this.changeset.enabledConstants.some(constant => constant.forgettingNumber != undefined);
  }
  get isDirty() {
    return this.changeset.isCustomDirty;
  }
  async save() {
    return await this.changeset.save();
  }
  getVitalSignLabel(item) {
    return this.intl.t(`vital-sign.${item.id}.long-description`);
  }
  getCompoundSurveyLabel(item) {
    const survey = this.store.peekRecord("compound-survey", item.surveyId);
    if (!survey) throw `No corresponding compound-survey found for the id '${item.surveyId}'`;
    return survey.title;
  }
  setDirtiness() {
    this.changeset.set("isCustomDirty", true);
  }
}, _defineProperty(_ConstantMonitoringEditionComponent, "fullComponentId", "constant-monitoring/edition-form"), _ConstantMonitoringEditionComponent), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "configuration", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "setDirtiness", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setDirtiness"), _class2.prototype), _class2);
export { ConstantMonitoringEditionComponent as default };